import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthContext";

const GlobalLegalFooter = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const hideOnRoutes = ["/register", "/login"];
  if (hideOnRoutes.includes(location.pathname)) {
    return null;
  }

  const termsHref = isAuthenticated ? "/legal/terms" : "/terms";
  const privacyHref = isAuthenticated ? "/legal/privacy" : "/privacy";

  return (
    <footer className="relative z-10 mt-auto border-t border-white/10 bg-slate-950/65 px-4 py-5 backdrop-blur-xl">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs text-slate-300">
        <Link to={termsHref} className="transition hover:text-cyan-300">
          {t("legal.links.terms")}
        </Link>
        <span aria-hidden="true" className="text-slate-500">
          •
        </span>
        <Link to={privacyHref} className="transition hover:text-cyan-300">
          {t("legal.links.privacy")}
        </Link>
        <span aria-hidden="true" className="hidden text-slate-500 sm:inline">
          •
        </span>
        <span className="text-slate-400">
          {t("legal.versionLabel", { version: "2026-05-07" })}
        </span>
      </div>
    </footer>
  );
};

export default GlobalLegalFooter;